import { api } from './index';

export const uploadApi = api.injectEndpoints({
    endpoints: (build) => ({
        uploadFile: build.mutation({
            query(body) {
                return {
                    url: '/upload',
                    method: 'POST',
                    body:body
                }
            }
        })
    })
});

export const {
    useUploadFileMutation
} = uploadApi;
